import React from 'react';
import { Text, Icon } from 'porosys-ui';
import './styles.scss';

const FormHeader = props => {
    const { handleCloseForm, formTitle } = props;

    return (
        <div className="form_header">
            <div className="flex space-between">
                <Text variant="h4">{formTitle}</Text>
                {handleCloseForm && <Icon fontSize={1.5} onClick={handleCloseForm} name="arrowCircleLeft" />}
            </div>
            <hr />
        </div>
    );
};

export default FormHeader;
